<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M9.12585 18.749C4.08648 18.749 0 14.6652 0 9.62585C0 4.58648 4.08648 0.5 9.12585 0.5C14.1652 0.5 18.2517 4.58648 18.2517 9.62585C18.249 14.6652 14.1652 18.749 9.12585 18.749Z"
      fill="url(#paint0_linear_1021_9540)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4922 5.80831C14.8486 6.16469 14.8486 6.74251 14.4922 7.0989L8.27047 13.3206C7.84733 13.7438 7.16129 13.7438 6.73815 13.3206L3.75948 10.342C3.40309 9.98558 3.40309 9.40776 3.75948 9.05138C4.11586 8.69499 4.69368 8.69499 5.05007 9.05138L7.50431 11.5056L13.2016 5.80831C13.558 5.45192 14.1358 5.45192 14.4922 5.80831Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1021_9540"
        x1="0"
        y1="0.5"
        x2="18.249"
        y2="18.7517"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88EE75" />
        <stop
          offset="1"
          stop-color="#00C23D"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
